import { render, staticRenderFns } from "./CustomerSidebar.vue?vue&type=template&id=732d6868&"
import script from "./CustomerSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports